import { computed, MaybeRef, unref } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import useDate from '@/composables/useDate'

type ContractDates = { startDate?: string | null; endDate?: string | null }

// An open-ended contract has no end date, so it reads as "No end date".
export function useContractTimeLine(contract: MaybeRef<ContractDates | null | undefined>) {
  return computed(() => {
    const dates = unref(contract)
    if (!dates) return { start: null, end: null }

    const start = dates.startDate ? useDate(dates.startDate).date.value : $t('No start date')
    const end = dates.endDate ? useDate(dates.endDate).date.value : $t('No end date')

    return { start, end }
  })
}
